import { Component, inject } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/index';
import { isMobile, TeachersService } from 'src/index/services.index';
import { inOutPaneAnimation } from '../../shared/animations';
import { HasDashboardSidebar } from '../../shared/mixins/has-dashboard-sidebar.mixin';

@Component({
    selector: 'meta-teacher-profile',
    templateUrl: './teacher-profile.component.html',
    styleUrls: ['./teacher-profile.component.css'],
    animations: [
        inOutPaneAnimation({ enterTime: '300ms', leaveTime: '300ms' }),
    ]
})
export class TeacherProfileComponent extends HasDashboardSidebar {
    route = inject(ActivatedRoute);
    teachersService = inject(TeachersService);

    config = { ...environment.helpModule };
    hideFooter = this.config.hideFooter || environment.hideFooter;

    appName = environment.name;
    hideChatToggler = environment.hideChat || environment.hideChatToggler || this.config.hideChatToggler;

    sideBarShown$ = new BehaviorSubject(!this.config.hideSidebar && !isMobile());

    override activeItem$ = new BehaviorSubject<string>('courses');

    teacherId: string | undefined = this.route.snapshot.params['id'];
}
